// extracted by mini-css-extract-plugin
module.exports = {"pageNF":"CciApps_pageNF__1gMen","spinner":"CciApps_spinner__3Kxrs","chart":"CciApps_chart__1scan"};